import { Navigate } from "react-router";
import AUTH_CONTEXT from "../store";
import { BASE_PATH_TO_AUTH } from "../base_routes_paths/auth_paths";

export const ProtectedRoutes = ({ children }) => {
    const authContext = AUTH_CONTEXT();
    // Guard: context can be undefined if rendered outside AuthContextProvider (e.g. module load order)
    if (!authContext) {
        return <Navigate to={BASE_PATH_TO_AUTH} />;
    }
    const { isLoggedIn } = authContext;
    if (!isLoggedIn) {
        return <Navigate to={BASE_PATH_TO_AUTH} />;
    }
    return children;
};